module.exports = __webpack_public_path__ + "img/ibs_04.50ad1698.png";